import { Link } from 'react-router-dom';
import cn from 'bem-cn';

import { Icon } from '../../Icon';
import { StepStatus } from '../Steps.types';
import { StepProps } from './Step.types';

import './Step.scss';

const b = cn('step');

export const Step = ({ step }: StepProps) => {
    const { text, icon, status, to, onClick, iconColor } = step;

    const stepContent = (
        <div className={b({ status })}>
            <div className={b('circle', { status })}>
                {icon && <Icon name={icon} fillColor={iconColor} className={b('icon')} />}
                {status === StepStatus.Done && (
                    <div className={b('check-mark')}>
                        <Icon name="smallTick" size={11} />
                    </div>
                )}
            </div>
            <div className={b('text')}>{text}</div>
        </div>
    );

    if (to) {
        return (
            <Link to={to} className={b('link')}>
                {stepContent}
            </Link>
        );
    }

    if (onClick) {
        return (
            <button type="button" onClick={onClick} className={b('button')}>
                {stepContent}
            </button>
        );
    }

    return stepContent;
};
